const actionTypes = {
    GET_REF_DATA_DEFAULT_CONFIGS: 'GET_REF_DATA_DEFAULT_CONFIGS',
};

export default actionTypes;